
export const DASHBOARD_PATH = '/dashboard';
const config = {    
    baseurl: process.env.REACT_APP_API_URL,
};
export default config;
